define('lib/binders/datepicker',['require','knockout','jquery','knockout-jqueryui/datepicker'],function (require) {
    var ko = require('knockout');
    var $ = require('jquery');
    require('knockout-jqueryui/datepicker');

    ko.bindingHandlers.datepicker = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var $el = $(element);
            // initialize datepicker with some optional options
            var options = allBindingsAccessor().datepickerOptions || {};
            $el.datepicker(options);

            // handle the field changing
            ko.utils.registerEventHandler(element, 'change', function () {
                var observable = valueAccessor();
                observable($el.datepicker('getDate'));
            });
        },
        update: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            var $el = $(element);
            var current = $el.datepicker('getDate');
            if (value - current !== 0) {
                $el.datepicker('setDate', value);
            }
        }
    };

    var updateDatepickerPosition = function () {
        if ($.datepicker._datepickerShowing) {
            var datepicker = $.datepicker._curInst;
            var dpElem = datepicker.dpDiv;

            var dpInput = $('.date-picker-form').offset();
            var dpInputHeight = $('.date-picker-form').height();

            setTimeout(function () {
                var dpOffsetLeft = datepicker.input.offset().left;
                var dpWidth = dpElem.outerWidth();
                if (window.innerWidth >= dpOffsetLeft + dpWidth) {
                    dpElem.css({
                        top: dpInput.top + dpInputHeight,
                        left: dpOffsetLeft
                    });
                } else {
                    dpElem.css({
                        top: dpInput.top + dpInputHeight,
                        left: window.innerWidth - dpWidth
                    });
                }
            }, 0);
        }
    };

    $(window).on('resize', updateDatepickerPosition);
});


